import { render, staticRenderFns } from "./namecolor.vue?vue&type=template&id=5ebff410&scoped=true&"
import script from "./namecolor.vue?vue&type=script&lang=js&"
export * from "./namecolor.vue?vue&type=script&lang=js&"
import style0 from "./namecolor.vue?vue&type=style&index=0&id=5ebff410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebff410",
  null
  
)

export default component.exports